export { default as AnalyticsInit } from './src/analytics-init';
